import axios from "axios";
import { ToolInfoDto } from "./models/ToolInfoDto";

export const getToolCapabilities = async (): Promise<ToolInfoDto[]> => {
  const { data } = await axios.get<ToolInfoDto[]>(
    `${window.configuration.apiUrl}api/tools/capabilities`
  );
  return data;
};
